<template>
    <div class="notification-warn" v-show="messageState" :style="btm">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <div class="notification-warn-title">{{ messageTitle }}</div>
                <i
                    class="notification-warn-close el-icon-close"
                    @click="onColse"
                ></i>
            </div>
            <div class="notification-warn-content">
                <div class="notification-content-top">
                    <p>您好！</p>
                    <el-button
                        type="text"
                        v-if="allList.length > 3"
                        @click="onView"
                        >{{ btnContent }}</el-button
                    >
                </div>
                <div class="notification-content-middle" :style="infoHeight">
                    <p v-for="(item, index) in shortList" :key="index">
                        {{ item.content }}
                    </p>
                </div>
            </div>
            <div class="notification-warn-footer">
                <el-button @click="onColse">已知悉</el-button>
                <el-button @click="onRemind">已知悉，无需再次提醒</el-button>
            </div>
        </el-card>
        <NotificationDialog ref="notificationDialog"></NotificationDialog>
    </div>
</template>

<script>
import NotificationDialog from "./NotificationDialog.vue";
import {
    selectWarningDetail,
    cancelLSPPopup
} from "../../api/notificationWarn.js";

export default {
    data() {
        return {
            allList: [],
            closeState: false,
            messageState: false,
            messageData: [],
            messageTitle: "消息提示",
            documentEarlyWarningType: "",//1 表示供应商消息提示、2 表示司机消息提示、3 表示车辆消息提示
            shortList: []
        };
    },
    mounted() {
        setTimeout(() => {
            this.init();
        }, 3000);
    },
    components: { NotificationDialog },
    computed: {
        infoHeight() {
            if (this.allList.length === 1) {
                return "height:72px;";
            }
            if (this.allList.length === 2) {
                return "height:120px;";
            }
            if (this.allList.length >= 3) {
                return "height:205px;";
            }
            return "height:72px;";
        },
        btm() {
            if (this.closeState) {
                return "bottom: -440px;opacity:0;";
            }
            if (this.allList.length === 1) {
                return "bottom: 5px;opacity:1;";
            }
            if (this.allList.length === 2) {
                return "bottom: 54px;opacity:1;";
            }
            if (this.allList.length >= 3) {
                return "bottom: 139px;opacity:1;";
            }
            return "";
        },
        btnContent() {
            const dataList = this.allList;
            if (Array.isArray(dataList) && dataList.length > 0) {
                return `查看全部 (${dataList.length})`;
            }
            return "查看全部";
        }
    },
    watch: {},
    methods: {
        init() {
            const value = sessionStorage.getItem("messageState");
            if (!value) {
                this.messageState = true;
                sessionStorage.setItem("messageState", true);
                this.getData();
            } else {
                this.messageState = false;
            }
        },
        getData() {
            if (!this.$store.state.supplier.supplierCode) {
                return false;
            }
            const params = {
                supplierCode: this.$store.state.supplier.supplierCode
            };
            selectWarningDetail(params).then(res => {
                if (res && +res.code === 0) {
                    this.messageData = [];
                    const {
                        supplierWarningList,
                        driverWarningList,
                        carWarningList
                    } = res.data;
                    // let supplierWarningList = [
                    //     {
                    //         businessType: "1",
                    //         certificateEndDate: "2024-07-22 00:00:00",
                    //         code: "HC0000147",
                    //         disrupttypename: null,
                    //         iname: null,
                    //         needToDoFlag: null,
                    //         qualificationName: "营业执照1"
                    //     }
                    // ];
                    if (
                        Array.isArray(supplierWarningList) &&
                        supplierWarningList.length > 0
                    ) {
                        this.messageData.push({
                            title: "供应商消息提示",
                            dataList: supplierWarningList
                        });
                    }
                    if (
                        Array.isArray(driverWarningList) &&
                        driverWarningList.length > 0
                    ) {
                        this.messageData.push({
                            title: "司机消息提示",
                            dataList: driverWarningList
                        });
                    }
                    if (
                        Array.isArray(carWarningList) &&
                        carWarningList.length > 0
                    ) {
                        this.messageData.push({
                            title: "车辆消息提示",
                            dataList: carWarningList
                        });
                    }
                    this.setMessagePrompt();
                }
            });
        },
        setMessagePrompt() {
            let messageData = this.messageData;
            if (Array.isArray(messageData) && messageData.length > 0) {
                this.allList = [];
                this.shortList = [];
                const { title, dataList } = messageData[0];
                this.messageTitle = title;
                if (title === "供应商消息提示") {
                    this.documentEarlyWarningType = "1";
                    for (let i = 0; i < dataList.length; i++) {
                        let item = dataList[i];
                        let rowData = { content: "" };
                        rowData.content = `【${item.qualificationName}】证件即将过期，到期时间：${item.certificateEndDate}，请及时更新，到期后系统将强制终止合作，供应商编码${item.code}`;
                        this.allList.push(rowData);
                        if (i < 3) {
                            this.shortList.push(rowData);
                        }
                    }
                } else if (title === "司机消息提示") {
                    this.documentEarlyWarningType = "2";
                    for (let i = 0; i < dataList.length; i++) {
                        let item = dataList[i];
                        let rowData = { content: "" };
                        rowData.content = `【${item.qualificationName}】证件即将过期，到期时间：${item.certificateEndDate}，请及时更新，到期后系统将强制终止合作，司机编码：${item.code}`;
                        this.allList.push(rowData);
                        if (i < 3) {
                            this.shortList.push(rowData);
                        }
                    }
                } else if (title === "车辆消息提示") {
                    this.documentEarlyWarningType = "3";
                    for (let i = 0; i < dataList.length; i++) {
                        let item = dataList[i];
                        let rowData = { content: "" };
                        rowData.content = `【${item.qualificationName}】证件即将过期，到期时间：${item.certificateEndDate}，请及时更新，到期后系统将强制终止合作，车牌号：${item.code}`;
                        this.allList.push(rowData);
                        if (i < 3) {
                            this.shortList.push(rowData);
                        }
                    }
                }
            }
        },
        onColse() {
            this.closeState = true;
            let messageData = this.messageData;
            if (Array.isArray(messageData) && messageData.length > 0) {
                messageData.shift();
                if (messageData.length < 1) {
                    return;
                }
                setTimeout(() => {
                    this.closeState = false;
                    this.setMessagePrompt();
                }, 1500);
            }
        },
        onRemind() {
            const params = {
                supplierCode: this.$store.state.supplier.supplierCode,
                documentEarlyWarningType: this.documentEarlyWarningType
            };
            if (!this.documentEarlyWarningType) {
                return;
            }
            cancelLSPPopup(params).then(res => {
                if (res && +res.code === 0) {
                    this.onColse();
                }
            });
        },
        onView() {
            this.$refs.notificationDialog.open(this.allList);
        }
    }
};
</script>

<style scoped lang="less">
.notification-warn {
    position: absolute;
    bottom: -440px;
    right: 80px;
    width: 280px;
    height: 208px;
    opacity: 0;
    transition: all 0.8s ease;
    z-index: 9999;

    /deep/.el-card__header {
        padding: 10px 18px;
    }

    &-title {
        // height: 30px;
        // line-height: 30px;
        text-align: center;
        // border: 1px solid blue;
    }

    &-close {
        position: absolute;
        right: 5px;
        top: 10px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
            color: #00bcbf;
        }
    }

    &-content {
        font-size: 12px;

        .notification-content-top {
            display: flex;
            height: 26px;
            align-items: center;
            justify-content: space-between;
        }

        .notification-content-middle {
            overflow: auto;
            p {
                margin: 6px 0;
            }
        }
    }

    &-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 5px 0;
        height: 30px;
        // border: 1px solid blue;
        // line-height: 30px;
        // text-align: center;
    }
}
</style>
